// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#GeneralSettings[data-v-6d6afbfa] .v-text-field__details{display:none!important}", ""]);
// Exports
module.exports = exports;
